import GoBackArrow from '@assets/sidebarNavigation/goBackArrow.png';
import EditPencilIcon from '@assets/common/editPencilIcon.png';

import AnalyticsIcon from '@assets/common/analyticsIcon.png';


//Object to handle naviagtion
export const navigationData = [
    {
        "title" : "Back to Articles",
        "route" : "/dynamic?tab=articles",
        "default" : false,        
        "icon" : GoBackArrow
    },
    {
        "title" : "Details",
        "component" : "Article Details",
        "default" : false,        
        "icon" : EditPencilIcon
    }
]
